import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { CancelGetter } from '@/store/cancel/cancel.module';
import { Cancel } from '@/store/cancel/cancel.model';
import { ProjectAttachment } from '@/store/project/project.model';
import BaseOffcanvasComponent from '@/components/baseOffcanvas/BaseOffcanvas.vue';

export default defineComponent({
  name: 'ProjectCancelAttachmentOffcanvasComponent',
  components: {
    BaseOffcanvasComponent
  },
  props: {
    projectId: {
      type: Number,
    },
  },
  setup: () => {
    const store = useStore();
    const cancel = computed<Cancel | undefined>(() => store.getters[CancelGetter.GET]);
    const attachments = computed<ProjectAttachment[]>(() => (cancel.value) ? cancel.value?.attachments.filter(m => m.attachmentType.id === 1) : []);
    const images = computed<ProjectAttachment[]>(() => (cancel.value) ? cancel.value?.attachments.filter(m => m.attachmentType.id === 2) : []);
    const attachmentOffcanvas = ref<InstanceType<typeof BaseOffcanvasComponent>>();

    // show modal
    const show = () => {
      attachmentOffcanvas.value?.show();
    };

    // hide modal
    const hide = () => {
      attachmentOffcanvas.value?.hide();
    };

    const attachmentClick = (url: string) => {
      window.open(url, '_blank');
    };

    return {
      attachments,
      images,
      attachmentOffcanvas,
      show,
      hide,
      attachmentClick,
    };
  }
});
